import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";

// allowIfResponsavelEmTurma: aluno ou responsável só passa se tem ao menos
// uma turma vinculada no backend. Bloqueia coord/responsável "fantasmas"
// sem vínculo de chegar em rotas que dependem disso (criar evento, lista
// de alunos, editar turma).
export const RoleRoute = ({
  allowed = [],
  allowIfResponsavelEmTurma = false,
}) => {
  const { usuario } = useAuth();
  const tipo = String(usuario?.tipo || "").toLowerCase();

  if (!tipo) return <Navigate to="/" replace />;

  // Aluno-responsável: continua tipo "aluno", mas é responsável de ≥1 turma.
  // Ganha acesso às rotas do fluxo responsável (protegidas por
  // allowIfResponsavelEmTurma), sem deixar de ser aluno.
  const turmasComoResponsavel = Array.isArray(usuario?.turmasComoResponsavel)
    ? usuario.turmasComoResponsavel
    : [];
  const ehAlunoResponsavel =
    tipo === "aluno" && turmasComoResponsavel.length > 0;

  const liberado =
    allowed.includes(tipo) || (allowIfResponsavelEmTurma && ehAlunoResponsavel);
  if (!liberado) return <Navigate to="/dashboard" replace />;

  if (allowIfResponsavelEmTurma) {
    // Coordenador: vínculo é coordenação. Responsável: vínculo é turma.
    // Aluno-responsável: vínculo relevante é turmasComoResponsavel.
    const turmas = Array.isArray(usuario?.turmas) ? usuario.turmas : [];
    const coordenacoes = Array.isArray(usuario?.coordenacoesComoCoordenador)
      ? usuario.coordenacoesComoCoordenador
      : [];
    let semVinculo;
    if (tipo === "coordenador") semVinculo = coordenacoes.length === 0;
    else if (ehAlunoResponsavel)
      semVinculo = turmasComoResponsavel.length === 0;
    else semVinculo = turmas.length === 0;
    if (semVinculo) return <Navigate to="/sem-turma" replace />;
  }

  return <Outlet />;
};
